import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Page = styled.div`
  margin-left: 3vw;
  ${props => props.theme.isXLarge && `
    margin-left: 5vw;
  `};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

// This will be a polymorphic anchor element.
const Header = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 12px;
  margin-bottom: 34px;
  text-transform: uppercase;
  color: ${props => props.theme.bodyColor};
`;

const Link = styled.a`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 13px;

  &:not(:first-child) {
    margin-bottom: 15px;
  }
`;

export default function SiteMapDesktop(props) {
  const { siteMap } = props;
  return (
    <React.Fragment>
      {siteMap.map(({ name, sections, url }) => (
        <Page key={name}>
          {url ? <Header as="a" href={url}>{name}</Header> : <Header>{name}</Header>}
          {sections.map(s => <Link key={s.name} href={s.url}>{s.name}</Link>)}
        </Page>
      ))}
    </React.Fragment>
  );
}

SiteMapDesktop.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
};
